module.exports = __webpack_public_path__ + "static/media/Genoa.feb45471.png";